<template>
  <div v-loading="loading">
    <el-tabs size="small" v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="平台设置" name="platform"></el-tab-pane>
      <el-tab-pane label="关于我们" name="e-about"></el-tab-pane>
      <el-tab-pane label="用户协议" name="user-agreement"></el-tab-pane>
      <el-tab-pane label="隐私政策" name="privacy-policy"></el-tab-pane>
      <el-tab-pane label="积分获取规则" name="point-gain-rules"></el-tab-pane>
      <el-tab-pane label="积分兑换规则" name="point-exc-rules"></el-tab-pane>
      <el-tab-pane label="积分兑换协议" name="point-exc-agreement"></el-tab-pane>
      <el-tab-pane label="提现规则" name="cash-rules"></el-tab-pane>
      <el-tab-pane label="实名认证协议" name="auth-protocol"></el-tab-pane>
    </el-tabs>
      <!--平台设置-->
      <platform v-if="activeName === 'platform'" />
      <!--用户协议-->
      <user-agreement v-if="activeName === 'user-agreement'" />
      <!--关于我们-->
      <about v-if="activeName === 'e-about'" />
      <!--隐私政策-->
      <privacy-policy v-if="activeName === 'privacy-policy'" />
      <!--积分获取规则-->
      <point-gain-rules v-if="activeName === 'point-gain-rules'" />
      <!--积分兑换规则-->
      <point-exc-rules v-if="activeName === 'point-exc-rules'" />
      <!--积分兑换协议-->
      <point-exc-agreement v-if="activeName === 'point-exc-agreement'" />
      <!--提现规则-->
      <cash-rules v-if="activeName === 'cash-rules'" />
      <!--实名认证协议-->
      <auth-protocol v-if="activeName === 'auth-protocol'" />
  </div>
</template>
<script>

import AuthProtocol from './part/auth-protocol';
import CashRules from './part/cash-rules';
import PointExcRules from './part/point-exc-rules';
import PointGainRules from './part/point-gain-rules';
import PointGainAgreement from './part/point-exc-agreement';
import PrivacyPolicy from './part/privacy-policy';
import UserAgreement from './part/user-agreement';
import platform from './part/platform';
import About from './part/about';
import PointExcAgreement from "@/views/education/setting/part/point-exc-agreement";
export default {
  components: {
      PointExcAgreement,
      AuthProtocol,
      CashRules,
      PointExcRules,
      UserAgreement,
      platform,
      PrivacyPolicy,
      PointGainRules,
      PointGainAgreement,
      About,
  },
  data() {
    return {
      /*是否正在加载*/
      loading:false,
      /*当前选中*/
      activeName: '',
      /*数据对象*/
      settingData:{}
    };
  },
  created() {
    // if (this.$route.query.type != null) {
    //   this.activeName = this.$route.query.type;
    // }else {
    //     this.activeName = 'discount'
    // }
      this.activeName = 'platform'
    // this.getData();

  },
  methods: {

    /*获取数据*/
    // getData() {
    //   let self = this;
    //   PlusApi.agentSet({}, true)
    //     .then(res => {
    //       self.settingData = res.data;
    //       self.loading=false;
    //       self.activeName='basic';
    //     })
    //     .catch(error => {});
    // },

    handleClick(e) {
      this.activeName = e.name;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/education/setting/index.vue